/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_JobsInputs */

const en_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const de_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobsuche`)
};

const fr_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const es_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const it_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const nl_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const pl_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const fi_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const da_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

const sv_landing_tab_jobs = /** @type {(inputs: Landing_Tab_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job search`)
};

/**
* | output |
* | --- |
* | "Job search" |
*
* @param {Landing_Tab_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_jobs = /** @type {((inputs?: Landing_Tab_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_jobs(inputs)
	if (locale === "fr") return fr_landing_tab_jobs(inputs)
	if (locale === "es") return es_landing_tab_jobs(inputs)
	if (locale === "it") return it_landing_tab_jobs(inputs)
	if (locale === "nl") return nl_landing_tab_jobs(inputs)
	if (locale === "pl") return pl_landing_tab_jobs(inputs)
	if (locale === "fi") return fi_landing_tab_jobs(inputs)
	if (locale === "da") return da_landing_tab_jobs(inputs)
	if (locale === "sv") return sv_landing_tab_jobs(inputs)
	return en_landing_tab_jobs(inputs)
});